/**
 * 物品获取计划。
 * 模板引用与运行时实例分离，计划只描述“取得什么”，不直接保存背包事实。
 */

import { z } from 'zod';
import { ItemTemplateProposalSchema } from './itemProposal';

const ItemAcquisitionQuantitySchema = z.number().int().min(1).max(999).default(1);

export const ItemTemplateReferencePlanSchema = z.object({
  kind: z.literal('template_ref'),
  templateId: z.string().min(1),
  quantity: ItemAcquisitionQuantitySchema,
});

export const ItemNewTemplatePlanSchema = z.object({
  kind: z.literal('template_new'),
  proposal: ItemTemplateProposalSchema,
  quantity: ItemAcquisitionQuantitySchema,
});

export const ItemUniqueInstancePlanSchema = z.object({
  kind: z.literal('unique_instance'),
  proposal: ItemTemplateProposalSchema,
});

export const ItemAcquisitionPlanSchema = z.discriminatedUnion('kind', [
  ItemTemplateReferencePlanSchema,
  ItemNewTemplatePlanSchema,
  ItemUniqueInstancePlanSchema,
]);

export type ItemTemplateReferencePlan = z.infer<typeof ItemTemplateReferencePlanSchema>;
export type ItemNewTemplatePlan = z.infer<typeof ItemNewTemplatePlanSchema>;
export type ItemUniqueInstancePlan = z.infer<typeof ItemUniqueInstancePlanSchema>;
export type ItemAcquisitionPlan = z.infer<typeof ItemAcquisitionPlanSchema>;
export type ItemAcquisitionPlanInput = z.input<typeof ItemAcquisitionPlanSchema>;
